import styled from "styled-components";

import HeadingBase from "core/Heading";
import BodyText from "core/BodyText";

import { regularFamily } from "core/fontStyles";
import { convertPxToRem } from "frontend/components/helpers";

export const Heading = styled(HeadingBase).attrs({
    size: "xl"
})``;

export const Subheading = styled(BodyText).attrs({
    size: "sm"
})`
    font-family: ${regularFamily};
    letter-spacing: ${convertPxToRem({ px: 1 })};
`;

export const SecondaryInfo = styled.ul`
    display: flex;
    font-family: ${regularFamily};

    li:not(:last-of-type) {
        margin-right: ${convertPxToRem({ px: 16 })};
    }
`;

export const StatsContainer = styled.div`
    ${Heading},
    ${Subheading} {
        display: block;
    }

    & > * {
        &:not(:last-child) {
            margin-bottom: ${convertPxToRem({ px: 8 })};
        }
    }
`;
